export default __webpack_public_path__ + "static/media/person.18e1ab82.svg";